import axios from "axios";

class BaseService {
  constructor() {
    // this.baseUrl = "http://176.98.40.110:7000/api/";
    this.baseUrl = process.env.REACT_APP_BASE_URL || "https://postest.efixfatura.com.tr/api/";

    axios.interceptors.request.use(
      function (config) {
        config.headers.common["x-auth-token"] = `Bearer ${localStorage.getItem("token")}`;
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        console.log(error);

        // if something goes bad with authentication redirect to login
        if (error.response && error.response.status === 401) {
          window.location.replace("/#/login");
        }

        // Çalışma saatleri kapısı: oturumu düşürme, proje seçimine dön
        if (
          error.response &&
          error.response.status === 403 &&
          error.response.data &&
          (error.response.data.message === "OUTSIDE_WORKING_HOURS" ||
            error.response.data.name === "OutsideWorkingHours")
        ) {
          const hash = (window.location.hash || "").toLowerCase();
          if (hash.indexOf("selectproject") === -1 && hash.indexOf("/login") === -1) {
            window.location.replace("/#/selectProject?outsideHours=1");
          }
        }

        // DMS kilit: oturumu düşürme, Belgelerim'e yönlendir
        if (
          error.response &&
          error.response.status === 403 &&
          error.response.data &&
          (error.response.data.code === "PROJECT_DOCUMENTS_LOCKED" ||
            error.response.data.message === "PROJECT_DOCUMENTS_LOCKED")
        ) {
          const hash = (window.location.hash || "").toLowerCase();
          if (
            hash.indexOf("my-documents") === -1 &&
            hash.indexOf("/login") === -1 &&
            hash.indexOf("selectproject") === -1
          ) {
            window.location.replace("/#/my-documents?locked=1");
          }
        }

        // response is undefined when a network error occurs
        if (error.response) {
          const data = error.response.data;
          const status = error.response.status;
          if (data && typeof data === "object" && !Array.isArray(data)) {
            return Promise.reject({ ...data, status });
          }
          return Promise.reject({ message: data, status });
        } else {
          let message = error.message;
          if (error.message === "Network Error") {
            message =
              "İşleminizi şu anda gerçekleştiremiyoruz, lütfen tekrar deneyiniz.";
          }
          return Promise.reject({ message });
        }
      }
    );
  }

  getBufferData(path) {
    let url = `${this.baseUrl}${path}`;
    return axios.get(`${url}`, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  postBufferData(path, data) {
    let url = `${this.baseUrl}${path}`;
    return axios.post(`${url}`, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getData(path) {
    let url = `${this.baseUrl}${path}`;
    return axios.get(`${url}`);
  }

  getDataWithParams(path, config = {}) {
    const url = `${this.baseUrl}${path}`;
    return axios.get(url, config);
  }

  putData(path, data) {
    let url = `${this.baseUrl}${path}`;
    return axios.put(`${url}`, data);
  }

  postData(path, data) {
    let url = `${this.baseUrl}${path}`;
    return axios.post(`${url}`, data);
  }

  postFormData(path, formData) {
    let url = `${this.baseUrl}${path}`;
    // Content-Type set edilmez; browser boundary ekler
    return axios.post(`${url}`, formData);
  }

  getBlobData(path) {
    let url = `${this.baseUrl}${path}`;
    return axios.get(`${url}`, {
      responseType: "blob",
    });
  }

  postDataToken(path, data, headers = {}) {
    let url = `${this.baseUrl}${path}`;
    return axios.post(`${url}`, data, { headers });
  }

  deleteData(path) {
    let url = `${this.baseUrl}${path}`;
    return axios.delete(`${url}`);
  }
}

export default new BaseService();
